var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row center"},[_c('div',{staticClass:"card blue-grey darken-1"},[_c('div',{staticClass:"card-action center"},[_c('button',{staticClass:"waves-effect waves-light btn-floating darken-5 z-depth-3 btn red",on:{"click":_vm.logOut}},[_vm._v("Salir del Sistema")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-897df8a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/logout.vue
// module id = 178
// module chunks = 0